(function(){
    angular
        .module('journey.tracker', [])
        .factory('trackerService', ['$http', '$templateCache', trackerService]);

    function trackerService($http, $templateCache){
        var getUserTrackerJourneys = function(){
            return $http({ method: 'GET', url: 'app/services/mocks/userJourneys.json' });
        };

        return {
            getUserTracker : getUserTrackerJourneys
        }

    }

})();



// WEBPACK FOOTER //
// ./app/services/tracker.service.js